module.exports = __webpack_public_path__ + "static/media/icon_extension_pptx.ba66c89e.svg";